import { render, staticRenderFns } from "./sortable-list.vue?vue&type=template&id=d791d136"
import script from "./sortable-list.vue?vue&type=script&lang=ts"
export * from "./sortable-list.vue?vue&type=script&lang=ts"
import style0 from "./sortable-list.vue?vue&type=style&index=0&id=d791d136&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports